import socketIOClient from "socket.io-client";

import * as mainActions from "./mainActions";
import * as runtimeActions from "./runtimeActions";

// const ENDPOINT = "http://127.0.0.1:4001";
let port = window.location.port === "3000" ? 4001 : window.location.port;
console.log(port);
const socket = socketIOClient(`${window.location.hostname}:${port}`);

socket.on("updateFrontend", (data) => {
	// console.log(data);
	mainActions.updateMainStore(data);
});

socket.on("print", (data) => {
	console.log(data);
});

socket.on("disconnect", () => {
	console.log("disconnect", socket.id);
	mainActions.socketDisconnected();
});

socket.on("connect", () => {
	console.log("connect", socket.id);
	socket.sendBuffer = [];
	mainActions.socketConnected();
	if (window.location.pathname.includes("output")) {
		socket.emit("updateBackend", { type: "ADD_OUTPUT", id: socket.id });
	}
});

export const updateSettings = (setting) => {
	return socket.emit("updateBackend", {
		type: "UPDATE_SETTINGS",
		setting,
	});
};

export const updateApp = () => {
	return socket.emit("updateBackend", { type: "UPDATE_APP" });
};
export const visitExternal = (link) => {
	return socket.emit("updateBackend", { type: "VISIT_EXTERNAL", link });
};

export const hideApp = () => {
	return socket.emit("updateBackend", { type: "HIDE_APP" });
};

export const quitApp = () => {
	return socket.emit("updateBackend", { type: "QUIT_APP" });
};

export const openSecondWindow = (window, id, windowType, displayIndex = -1) => {
	return socket.emit("updateBackend", {
		type: "OPEN_SECOND_WINDOW",
		window,
		id,
		windowType,
		displayIndex,
	});
};

export const settingsAction = (action, options = {}) => {
	return socket.emit("updateBackend", {
		type: "SETTINGS_ACTION",
		action,
		options,
	});
};

export const importTheme = (projectId) => {
	return socket.emit("updateBackend", {
		type: "BEGIN_IMPORT_THEME",
		projectId,
	});
};

export const importCSV = (projectId, listIndex) => {
	return socket.emit("updateBackend", {
		type: "IMPORT_CSV",
		projectId,
		listIndex,
	});
};

export const syncInit = (projectId) => {
	return socket.emit("updateBackend", {
		type: "SYNC_INIT",
		projectId,
	});
};

export const syncDown = (projectId) => {
	return socket.emit("updateBackend", {
		type: "SYNC_DOWN",
		projectId,
	});
};

export const duplicateProject = (duplicateId) => {
	return socket.emit("updateBackend", {
		type: "DUPLICATE_PROJECT",
		duplicateId,
	});
};

export const deleteProject = (projectId) => {
	return socket.emit("updateBackend", {
		type: "DELETE_PROJECT",
		projectId,
	});
};
export const getAvailableDisplays = () => {
	return socket.emit("updateBackend", {
		type: "GET_AVAILABLE_DISPLAYS",
	});
};

export const updateIpAddresses = () => {
	return socket.emit("updateBackend", {
		type: "UPDATE_IP_ADDRESSES",
	});
};

// RUNTIME

socket.on("updateFrontendRuntime", (data) => {
	// console.log(data);
	runtimeActions.updateRuntimeStore(data);
});

export const updateRuntimeData = (data) => {
	return socket.emit("updateBackendRuntime", {
		type: "UPDATE_SETTINGS",
		data,
	});
};
